import React from 'react';
import { ResponsiveScatterPlot } from '@nivo/scatterplot';

export default function Plan() {
  const getColor = (x, y) => {
    const normX = x / 100;
    const normY = y / 100;
    
const topRight = { r: 204, g: 12, b: 89 };
    const topLeft = { r: 255, g: 182, b: 193 };
 const bottomRight = { r: 202, g: 176, b: 255 };
    const bottomLeft = { r: 173, g: 216, b: 230 };
    
    const top = {
      r: topLeft.r + (topRight.r - topLeft.r) * normX,
      g: topLeft.g + (topRight.g - topLeft.g) * normX,
      b: topLeft.b + (topRight.b - topLeft.b) * normX,
    };
    
    const bottom = {
      r: bottomLeft.r + (bottomRight.r - bottomLeft.r) * normX,
      g: bottomLeft.g + (bottomRight.g - bottomLeft.g) * normX,
      b: bottomLeft.b + (bottomRight.b - bottomLeft.b) * normX,
    };
    
    const final = {
      r: Math.round(bottom.r + (top.r - bottom.r) * normY),
      g: Math.round(bottom.g + (top.g - bottom.g) * normY),
      b: Math.round(bottom.b + (top.b - bottom.b) * normY),
    };
    
    return `rgb(${final.r}, ${final.g}, ${final.b})`;
  };

const data = [
  {
    id: "relationships",
    data: [
      // Top Right Region - High Duration, High Intensity (Dark Red)
      { x: 98, y: 96 },
      { x: 83, y: 91 },
      { x: 71, y: 79 },
      { x: 89, y: 84 },
      
      // Top Left Region - Low Duration, High Intensity (Pink)
      { x: 3, y: 94 },
      { x: 26, y: 91 },
      { x: 11, y: 79 },
      { x: 19, y: 83 },
      
      // Bottom Right Region - High Duration, Low Intensity (Purple)
      { x: 95, y: 7 },
      { x: 82, y: 14 },
      { x: 88, y: 21 },
      { x: 74, y: 11 },
      
      // Bottom Left Region - Low Duration, Low Intensity (Muted Blue)
      { x: 5, y: 9 },
      { x: 24, y: 12 },
      { x: 9, y: 22 },
      { x: 18, y: 6 },
      
      // Scattered throughout to avoid dead zones
      { x: 52, y: 40 },
      { x: 52, y: 89 },
      { x: 44, y: 12 },
      { x: 8, y: 47 },
      { x: 93, y: 54 },
      { x: 45, y: 67 },
      { x: 67, y: 34 },
      { x: 35, y: 41 },
      { x: 68, y: 61 },
      { x: 29, y: 58 },
    ]
  }
];

  const NodesLayer = ({ nodes, xScale, yScale }) => {
    return (
      <g>
        {nodes.map((node) => (
          <circle
            key={node.id}
            cx={node.x}
            cy={node.y}
            r={6}
            fill={getColor(node.data.x, node.data.y)}
            stroke="white"
            strokeWidth={1}
          />
        ))}
      </g>
    );
  };

  return (
    <div style={{ height: '100%', width: '100%', pointerEvents: 'none', touchAction: 'none' }}>
    <ResponsiveScatterPlot
        data={data}
        margin={{ top: 10, right: 30, bottom: 35, left: 50 }}
        xScale={{ type: 'linear', min: 0, max: 100 }}
        yScale={{ type: 'linear', min: 0, max: 100 }}
        axisTop={null}
        axisRight={null}
         isInteractive={false}
        axisBottom={{
          tickSize: 0,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Duration',
          legendPosition: 'middle',
          legendOffset: 25,
          tickValues: [10, 95],
          format: (value) => value === 10 ? 'Short' : 'Long',
        }}
        axisLeft={{
          tickSize: 0,
          tickPadding: 5,
          tickRotation: 0,
          legend: 'Intensity',
          legendPosition: 'middle',
          legendOffset: -35,
          tickValues: [10, 95],
          format: (value) => value === 10 ? 'Low' : 'High',
        }}
        layers={['grid', 'axes', NodesLayer, 'mesh', 'legends']}
         theme={{
          background: 'transparent',
        //   text: {
        //     fill: '#ffffff',
        //     fontSize: 11
        //   },
          axis: {
            domain: {
              line: {
                stroke: '#777777',
                strokeWidth: 1
              }
            },
            legend: {
              text: {
                fill: '#5b5b5bff',
                fontSize: 14,
                fontWeight: 600
              }
            },
            ticks: {
              line: {
                stroke: '#777777',
                strokeWidth: 1
              },
              text: {
                fill: '#4e4e4eff',
                fontSize: 10
              }
            }
          },
          grid: {
            line: {
              strokeWidth: 0,
            //   stroke: '#44444419',
            //   strokeDasharray: '4 4'
            }
          },
        //   crosshair: {
        //     line: {
        //       stroke: '#ffffff',
        //       strokeWidth: 1,
        //       strokeOpacity: 0.35
        //     }
        //   }
        }}
        useMesh={true}
      />
    </div>
  );
}